// export const apiUrl = "http://localhost:5000"; //test
export const apiUrl = "https://emeeting-backend-2eejzzo3da-as.a.run.app"; //production

// export const domainName = "http://localhost:3000"; //test
// export const domainName = "https://emeeting-frontend-2eejzzo3da-as.a.run.app"; //production
export const domainName = "https://emeeting.arda.or.th";
